import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export const MobileWhatsAppButton = () => (
  <motion.a
    href="https://wa.me/393760873342"
    target="_blank"
    rel="noopener noreferrer"
    initial={{ y: 90, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, delay: 1.8, ease: [0.22, 1, 0.36, 1] }}
    data-testid="mobile-whatsapp-fab"
    aria-label="Prenota su WhatsApp"
    className="lg:hidden fixed z-40 left-1/2 -translate-x-1/2 flex items-center gap-2.5 bg-[#84232a] text-[#fbf6f1] pl-3 pr-6 py-2.5 rounded-full shadow-xl shadow-[#84232a]/30"
    style={{ bottom: "calc(1.25rem + env(safe-area-inset-bottom))" }}
  >
    <span className="w-9 h-9 rounded-full bg-[#fbf6f1]/15 flex items-center justify-center">
      <MessageCircle className="w-4 h-4" />
    </span>
    <span className="text-sm font-medium tracking-wide">Prenota su WhatsApp</span>
  </motion.a>
);
